export type QuestionBubbleProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

export function QuestionBubble({
  text,
  onClick,
  disabled = false,
  className = "",
}: QuestionBubbleProps) {
  return (
    <button
      type="button"
      className={`vcw-row question ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="vcw-bubble question">
        <div className="vcw-msg-text">{text}</div>
      </div>
    </button>
  );
}
